<style lang="scss" scoped>
$font-size-base: 1rem;
$font-size-lg: ($font-size-base * 1.25);
$font-size-sm: ($font-size-base * 0.875);
$input-height: 1.6rem;
$input-btn-focus-width: 0rem;
$custom-control-indicator-bg: #dee2e6;
$custom-control-indicator-disabled-bg: #f8a37e;
$custom-control-description-disabled-color: #dee2e6;
$white: white;
$theme-colors: (
    "primary": #f2644a
);

//
// These variables can be used to customize the switch component.
//
$switch-height: calc(#{$input-height} * 0.8) !default;
$switch-border-radius: $switch-height !default;
$switch-bg: $custom-control-indicator-bg !default;
$switch-checked-bg: map-get($theme-colors, "primary") !default;
$switch-disabled-bg: $custom-control-indicator-disabled-bg !default;
$switch-disabled-color: $custom-control-description-disabled-color !default;
$switch-thumb-bg: $white !default;
$switch-thumb-border-radius: 50% !default;
$switch-thumb-padding: 2px !default;
$switch-focus-box-shadow: 0 0 0 $input-btn-focus-width
    rgba(map-get($theme-colors, "primary"), 0.25);
$switch-transition: 0.2s all !default;

.switch {
    font-size: $font-size-base;
    position: relative;

    input {
        position: absolute;
        height: 1px;
        width: 1px;
        background: none;
        border: 0;
        clip: rect(0 0 0 0);
        clip-path: inset(50%);
        overflow: hidden;
        padding: 0;

        + label {
            position: relative;
            min-width: calc(#{$switch-height} * 2);
            border-radius: $switch-border-radius;
            height: $switch-height;
            line-height: $switch-height;
            display: inline-block;
            cursor: pointer;
            outline: none;
            user-select: none;
            vertical-align: middle;
            text-indent: calc(calc(#{$switch-height} * 2) + 0.5rem);
        }

        + label::before,
        + label::after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: calc(#{$switch-height} * 2);
            bottom: 0;
            display: block;
        }

        + label::before {
            right: 0;
            background-color: $switch-bg;
            border-radius: $switch-border-radius;
            transition: $switch-transition;
        }

        + label::after {
            top: $switch-thumb-padding;
            left: $switch-thumb-padding;
            width: calc(#{$switch-height} - calc(#{$switch-thumb-padding} * 2));
            height: calc(
                #{$switch-height} - calc(#{$switch-thumb-padding} * 2)
            );
            border-radius: $switch-thumb-border-radius;
            background-color: $switch-thumb-bg;
            transition: $switch-transition;
        }

        &:checked + label::before {
            background-color: $switch-checked-bg;
        }

        &:checked + label::after {
            margin-left: $switch-height;
        }

        &:focus + label::before {
            outline: none;
            box-shadow: $switch-focus-box-shadow;
        }

        &:disabled + label {
            color: $switch-disabled-color;
            cursor: not-allowed;
        }

        &:disabled + label::before {
            color: $switch-disabled-color;
        }
        &:checked:disabled + label::before {
            background-color: $switch-disabled-bg;
        }
    }

    + .switch {
        margin-left: 1rem;
    }
}
</style>

<template>
    <box>
        <template slot="content">
            <div class="row" v-for="(notification, key, index) in notifications" :key="key">
                <div class="col-12">
                    <!-- Header -->
                    <div class="row mt-20 mb-10">
                        <div class="col-12 col-md-8">
                            <p class="text-primary text-uppercase fs-12 fw-semi-bold mb-0">{{ notification.name }}</p>
                        </div>
                        <div class="col-12 col-md-2">
                            <p v-if="index === 0" class="mb-0 fs-12 fw-semi-bold mb-0">{{ $t('bin.mail') }}</p>
                        </div>
                        <div class="col-12 col-md-2">
                            <p v-if="index === 0" class="mb-0 fs-12 fw-semi-bold mb-0">{{ $t('bin.push') }}</p>
                        </div>
                    </div>

                    <!-- Content -->
                    <div class="row" v-for="(s, s_key) in notification.switches" :key="s_key">
                        <div class="col-12 col-md-8">
                            <p class="mb-0 fs-16 text-secondary fw-normal">{{ $t(`profile.alerts.toggles.${s_key}`) }}</p>
                        </div>
                        <div class="col-12 col-md-2">
                            <span class="switch">
                                <input v-model="s.mail" type="checkbox" class="switch" :id="s_key + '_mail_switch'" :disabled="s.mail_disabled">
                                <label :for="s_key + '_mail_switch'"></label>
                            </span>
                        </div>
                        <div class="col-12 col-md-2">
                            <span class="switch">
                                <input v-model="s.push" type="checkbox" class="switch" :id="s_key + '_push_switch'" :disabled="s.push_disabled">
                                <label :for="s_key + '_push_switch'"></label>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-30">
                <div class="col-12">
                    <button class="btn btn-primary" @click="submit">{{ $t('bin.save') }}</button>
                </div>
            </div>
        </template>
    </box>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
    data() {
        return {
            notifications: {
                messages: {
                    name: this.$t("profile.alerts.groups.chat"),
                    switches: {
                        messages: { mail: false, push: false }
                    }
                },

                ratings: {
                    name: this.$t("profile.alerts.groups.rating"),
                    switches: {
                        ratings: { mail: false, push: false }
                    }
                },

                drivers: {
                    name: this.$t("profile.alerts.groups.driver"),
                    switches: {
                        driver_newshipment: { mail: false, push: false },
                        driver_shipments: {
                            mail: false,
                            push: false,
                            push_disabled: true
                        },
                        driver_offeroverview: {
                            mail: false,
                            push: false,
                            push_disabled: true
                        }
                    }
                }
            }
        };
    },
    mounted() {
        this.initFields();
    },
    methods: {
        ...mapActions(["updateUser"]),
        initFields() {
            if (this.user) {
                for (var groupKey in this.notifications) {
                    console.log(groupKey, this.notifications[groupKey]);
                    for (var switchKey in this.notifications[groupKey]
                        .switches) {
                        this.notifications[groupKey].switches[
                            switchKey
                        ].push = this.user.settings[`push_${switchKey}`];
                        this.notifications[groupKey].switches[
                            switchKey
                        ].mail = this.user.settings[`mail_${switchKey}`];
                    }
                }
            }
        },

        submit() {
            let input = {
                id: this.user.id,
                settings: {
                    id: this.user.settings.id
                }
            };

            for (var groupKey in this.notifications) {
                console.log(groupKey, this.notifications[groupKey]);
                for (var switchKey in this.notifications[groupKey].switches) {
                    input.settings[`push_${switchKey}`] = this.notifications[
                        groupKey
                    ].switches[switchKey].push;
                    input.settings[`mail_${switchKey}`] = this.notifications[
                        groupKey
                    ].switches[switchKey].mail;
                }
            }

            this.updateUser(input)
                .then(resp => {
                    this.$toasted.show(this.$t("profile.toast.savesuccess"));
                    // this.initFields()
                })
                .catch(err => {
                    this.initFields();
                    console.log(err);
                    console.log(err.response);
                });
        }
    },
    computed: {
        ...mapGetters(["user"])
    },
    watch: {
        user: function() {
            this.initFields();
        }
    }
};
</script>
